// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2WdOg","subheader":"ReorderModal_subheader__BBuR6","listWrap":"ReorderModal_listWrap___tALv"};